import Vue from 'vue';
import Router from 'vue-router';
// import $utils from '@/utils/c.utils-0.1.0' // 工具类
import { constantRouterMap } from './router.config.js';
import { code2userinfo, redirectUrl, getSignature, isLogin, getUserInfo } from '@/api';

// 重写路由的push方法解决两次访问相同路由地址报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);
const createRouter = () => new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRouterMap,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});
const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title;
  let href = location.href;
  const IS_PROD = ['production', 'prod'].includes(process.env.NODE_ENV);
  let appId = IS_PROD ? 'wxd12d31cf907e12ba' : 'wx6c7d1490c3d49887';
  console.log(process.env);
  if (href.includes('com/?code') || href.includes('8090/?code')) {
    // url包括 com/?code 证明为从微信跳转回来的
    let hrefIndex = href.indexOf('#/');
    let hrefLeft = href.substring(0, hrefIndex);
    let urlRight = href.substring(hrefIndex, href.length); // url右侧部分
    var jingPosit = href.includes('com/?code') ? hrefLeft.indexOf("com/") + 4 : hrefLeft.indexOf("8090/") + 4; // 获取域名结束的位置
    var urlLeft = hrefLeft.substring(0, jingPosit); //url左侧部分
    var urlCode = hrefLeft.substring(jingPosit, hrefLeft.length); // url code
    if (urlRight.indexOf('?') >= 0) urlCode = urlCode.replace('?', '&');
    console.log('href', href);
    console.log('location', urlLeft + urlRight + urlCode);
    window.location = urlLeft + urlRight + urlCode; // 拼接跳转
  } else {
    if (to.query.code) {
      if (!localStorage.getItem('token')) {
        code2userinfo({
          data: {
            appId: appId,
            code: to.query.code
          }
        }).then(res => {
          localStorage.setItem('token', res.data);
          getSignature({
            data: {
              url: href.split('#')[0]
            }
          }).then(res => {
            if (res.data) {
              localStorage.setItem('signature', JSON.stringify(res.data));
            }
          });
          getUserStatus();
          next();
        });
      } else {
        isLogin().then(res => {
          if (!res.data) {
            code2userinfo({
              data: {
                appId: appId,
                code: to.query.code
              }
            }).then(res => {
              localStorage.setItem('token', res.data);
              getSignature({
                data: {
                  url: href.split('#')[0]
                }
              }).then(res => {
                if (res.data) {
                  localStorage.setItem('signature', JSON.stringify(res.data));
                }
              });
              getUserStatus();
              next();
            });
          } else {
            getUserStatus();
            next();
          }
        });
      }
    } else {
      if (localStorage.getItem('token')) {
        isLogin().then(res => {
          if (!res.data) {
            if (location.hostname !== 'localhost') {
              redirectUrl({
                data: {
                  appId: appId,
                  redirectUri: href,
                  scope: 'snsapi_userinfo',
                  state: ''
                }
              }).then(res => {
                if (res.data) {
                  console.log(res.data);
                  location.href = res.data;
                }
              });
            }
          } else {
            getUserStatus();
          }
          if (!localStorage.getItem('signature')) {
            getSignature({
              data: {
                url: href.split('#')[0]
              }
            }).then(res => {
              if (res.data) {
                localStorage.setItem('signature', JSON.stringify(res.data));
                console.log('signature', res.data);
              }
            });
          }
        });
        next();
      } else {
        // if ($utils.isWeiXin()) {
        if (location.hostname !== 'localhost') {
          redirectUrl({
            data: {
              appId: appId,
              redirectUri: href,
              scope: 'snsapi_userinfo',
              state: ''
            }
          }).then(res => {
            if (res.data) {
              console.log(res.data);
              location.href = res.data;
            }
          });
        }
        next();
        // } else {
        //   next()
        // }
      }
    }
  }
});

function getUserStatus() {
  getUserInfo().then(res => {
    if (res.data) {
      // this.$store.setUserStatus
      localStorage.setItem('activeStatus', res.data.activeStatus);
    }
  });
}